import { Select } from 'antd';
import { defaultTaskStatuses, TaskStatus, TaskStatusGroup, TaskStatusGroupUtils } from '../../types/TaskStatus';
import StatusLabel, { StatusComponentType } from './StatusLabel';
import './StatusDropdown.scss';
import { useGetWorkspace } from '../../serverState/workspace';
import { useState } from 'react';
import { groupBy } from '../../utils/arrayUtils';

const { Option, OptGroup } = Select;

export type ReplacingStatusDropdownProps = {
  onSelect: (statusId: number) => void;
  onEditStatuses: () => void;
  onBlur: () => void;
  filterStatus: TaskStatus;
};

const ReplacingStatusDropdown = (props: ReplacingStatusDropdownProps) => {
  const workspaceQuery = useGetWorkspace();
  const statusOptions: TaskStatus[] = ((workspaceQuery.data?.TaskStatus as TaskStatus[]) || defaultTaskStatuses).filter(
    (status) => status.id !== props.filterStatus.id
  );
  const defaultStatus = statusOptions.find((option) => option.default);
  const groupedOptions = groupBy(statusOptions, 'group');

  const [selectedStatus, setSelectedStatus] = useState<string | undefined>(defaultStatus?.title);

  const handleChange = (value: string) => {
    setSelectedStatus(value);
  };

  const onSelect = (value: string) => {
    const selected = statusOptions.find((status) => status.title === value);
    setSelectedStatus(selected?.title);
    props.onSelect(selected?.id || statusOptions[0].id);
  };

  const handleClick = () => {
    console.log('Clicked');
    props.onEditStatuses();
  };

  return (
    <Select
      showSearch={false}
      filterOption={false}
      defaultOpen={false}
      autoFocus={true}
      onChange={handleChange}
      className={'w-[240px] h-[36px]'}
      listHeight={300}
      onSelect={onSelect}
      onBlur={props.onBlur}
      popupMatchSelectWidth={false}
      placeholder="Select replacing task status"
      dropdownStyle={{ width: '180px', zIndex: 2001 }}
      value={selectedStatus}
    >
      {Object.values(TaskStatusGroup).map((group) => (
        <OptGroup
          key={group}
          label={TaskStatusGroupUtils.getTitle(group)}
          className="text-xs font-semibold font-['Figtree'] text-neutral-900"
        >
          {groupedOptions[group].map((status) => (
            <Option key={status.title} value={status.title}>
              <StatusLabel
                color={status.color}
                title={status.title}
                group={status.group}
                component={StatusComponentType.Dropdown}
              />
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};

export default ReplacingStatusDropdown;
